<template>
  <v-container>
    <div class="mb-8">
      <v-btn
        color="primary"
        fab
        class="mt-4"
        @click="addNew = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <div style="text-align: center; margin-bottom: 100px;" v-if="!loading && !maps.length">
      <v-icon size="100">
        mdi-dots-hexagon
      </v-icon>
      <h2 class="mt-3">
        {{$t('maps.no_maps')}}
      </h2>
      <v-btn class="mt-6" color="primary" @click="addNew = true">
        <v-icon>mdi-plus</v-icon>
        {{$t('maps.add_a_map')}}
      </v-btn>
    </div>
    <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="map in maps"
          :key="'mapvatdd' + map.id"
          @click="openMap(map)"
        >
          <map-card
            @modify="startModify(map)"
            @delete="startDeleteMap(map.id)"
            style="cursor: pointer;"
            :map="map"
          ></map-card>
        </v-col>
    </v-row>
    <v-row>

    </v-row>
    <v-dialog
      max-width="1000"
      v-model="addNew"
      @click:outside="addNew = false"
    >
      <add-map 
        @close="addNew = false"
        @startDrawing="drawMapKey++; draw = true; drawing_base = $event; addNew = false"
      ></add-map>
    </v-dialog>
    <v-dialog
      v-model="draw"
      permanent
    >
      <draw-map
        @close="draw = false; drawing_base = null; modify_map = null" 
        :base="drawing_base"
        :modify="modify_map"
        :key="drawMapKey"
      ></draw-map>
    </v-dialog>
    <v-dialog style="position: relative;" v-model="mapIsOpened">
      <open-map
        @close="mapIsOpened = false;"
        :key="openMapKey"
        :map="openedMap"
      ></open-map>
    </v-dialog>
  </v-container>
</template>

<script>
import AddMap from '@/components/maps/AddMap.vue'
import OpenMap from '@/components/maps/OpenMap.vue'
import DrawMap from '@/components/maps/DrawMap.vue'
import { mapGetters, mapActions } from 'vuex'
import MapCard from '@/components/maps/MapCard.vue'
export default {
  components: { AddMap, DrawMap, MapCard, OpenMap },
  data: () => ({
    addNew: false,
    loading: false,
    draw: false,
    drawing_base: null,
    mapIsOpened: false,
    openedMap: null,
    openMapKey: 0,
    modify_map: null,
    drawMapKey: 0
  }),
  created() {
    this.initMaps()
  },
  methods: {
    ...mapActions('map', [ 'initMaps','deleteMap' ]),
    ...mapActions('noti', [ 'info', 'error' ]),
    openMap(map) {
      this.mapIsOpened = true
      this.openedMap = map
      this.openMapKey++
    },
    startModify(map) {
      this.modify_map = map; 
      this.$nextTick(() => {
        this.draw = true
        this.drawMapKey++
      })
    },
    startDeleteMap(id) {
      this.deleteMap(id)
        .then(() => this.info(this.$t('maps.map_deleted')))
        .catch(e => this.error(e))
    }
  },
  computed: {
    ...mapGetters('map', [
      'maps'
    ])
  }
}
</script>